module.exports = __webpack_public_path__ + "static/media/1POLICY39.421076df.jpg";